import { z } from "zod";
import { PatchApplicabilityReasonSchema } from "./patches.js";
/** Studio-facing lifecycle for L2 agency patch attempts (honest rollup; no raw QA blobs). */
export const AgencyEditorPatchPhaseSchema = z.enum([
    "RECEIVED",
    "VALIDATION_FAILED",
    "REJECTED",
    "ACCEPTED_PENDING_GENERATION",
    "GENERATING",
    "QA_RUNNING",
    "QA_PASS",
    "QA_WARN",
    "QA_FAIL",
    "CONTRADICTION_BLOCKED",
    "ACTIVATION_REJECTED",
    "ACTIVE",
    "SUPERSEDED",
    "FAILED",
]);
export const AgencyEditorPatchOutcomeV1Schema = z
    .object({
    schemaId: z.literal("agency-editor-patch-outcome.v1"),
    attemptId: z.string().min(1),
    patchId: z.string().min(1),
    status: z.enum(["REJECTED", "ACCEPTED"]),
    phase: AgencyEditorPatchPhaseSchema,
    reasonCodes: z.array(PatchApplicabilityReasonSchema).optional(),
    warningCodes: z.array(PatchApplicabilityReasonSchema).optional(),
    fromRevisionId: z.string().nullable().optional(),
    toRevisionId: z.string().nullable().optional(),
})
    .strict();
export const AgencyEditorPatchAttemptSummaryV1Schema = z
    .object({
    schemaId: z.literal("agency-editor-patch-attempt-summary.v1"),
    attemptId: z.string().min(1),
    patchId: z.string().min(1),
    status: z.enum(["REJECTED", "ACCEPTED"]),
    phase: AgencyEditorPatchPhaseSchema,
    reasonCodes: z.array(PatchApplicabilityReasonSchema).optional(),
    warningCodes: z.array(PatchApplicabilityReasonSchema).optional(),
    fromRevisionId: z.string().nullable(),
    toRevisionId: z.string().nullable(),
    createdAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=agency-editor-patch-outcome.js.map